import { render } from "./EditOrderCard.vue?vue&type=template&id=ffef82e4"
import script from "./EditOrderCard.vue?vue&type=script&lang=js"
export * from "./EditOrderCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__